'use client';

import {
  Accordion,
  AccordionContent,
  AccordionHeader,
  BodyLinkV3,
  LayoutGrid,
  TypographyRhythm,
  TypographyV3,
} from '@jouzen/ecom-components';
import { useTranslations } from 'next-intl';

import RichText from '@/app/components/RichText';

const link = (chunks: React.ReactNode) => (
  <BodyLinkV3
    external
    href="https://ouraringhelp.zendesk.com/hc/en-us/requests/new"
    target="_blank"
    rel="noopener noreferrer"
  >
    {chunks}
  </BodyLinkV3>
);

const Content = () => {
  const t = useTranslations();

  return (
    <>
      <TypographyV3 variant="h2" Element="h1" align="center" className="mb-24">
        {t('b2b_terms_2_7_term')}
      </TypographyV3>

      <LayoutGrid rowGap={32}>
        <div className="col-main lg:col-end-12">
          <TypographyV3 Element="h2" variant="h3">
            {t('checkout_shippinginformation')}
          </TypographyV3>
        </div>
        <div className="col-main lg:col-start-13">
          <Accordion openAtIndex={1} isContentAnimated={false}>
            <AccordionHeader>
              <TypographyV3
                variant="unset"
                Element="h4"
                weight="thin"
                className="max-w-[90%] py-4 text-xl lg:text-3xl"
              >
                {t('shipping_info_faq_question_1')}
              </TypographyV3>
            </AccordionHeader>
            <AccordionContent>
              <div className="pb-4">
                <TypographyRhythm>
                  <TypographyV3>
                    <RichText
                      messageKey="shipping_info_faq_answer_1_1"
                      tValues={{ link }}
                    />
                  </TypographyV3>
                  <TypographyV3>
                    {t('shipping_info_faq_answer_1_2')}
                  </TypographyV3>
                </TypographyRhythm>
              </div>
            </AccordionContent>

            <AccordionHeader>
              <TypographyV3
                variant="unset"
                Element="h4"
                weight="thin"
                className="max-w-[90%] py-4 text-xl lg:text-3xl"
              >
                {t('shipping_info_faq_question_2')}
              </TypographyV3>
            </AccordionHeader>
            <AccordionContent>
              <div className="pb-4">
                <TypographyV3 Element="dt" className="mb-4">
                  {t('shipping_info_faq_answer_2_1')}
                </TypographyV3>
                <div className="mb-8 ml-8">
                  <TypographyV3 Element="dd">
                    {t('shipping_info_faq_answer_2_2')}
                  </TypographyV3>
                  <TypographyV3 Element="dd">
                    {t('shipping_info_faq_answer_2_3')}
                  </TypographyV3>
                  <TypographyV3 Element="dd">
                    {t('shipping_info_faq_answer_2_4')}
                  </TypographyV3>
                  <TypographyV3 Element="dd">
                    {t('shipping_info_faq_answer_2_5')}
                  </TypographyV3>
                </div>

                <TypographyV3 Element="dt" className="mb-4">
                  {t('shipping_info_faq_answer_2_6')}
                </TypographyV3>
                <div className="mb-8 ml-8">
                  <TypographyV3 Element="dd">
                    {t('shipping_info_faq_answer_2_7')}
                  </TypographyV3>
                  <TypographyV3 Element="dd">
                    {t('shipping_info_faq_answer_2_3')}
                  </TypographyV3>
                  <TypographyV3 Element="dd">
                    {t('shipping_info_faq_answer_2_4')}
                  </TypographyV3>
                  <TypographyV3 Element="dd">
                    {t('shipping_info_faq_answer_2_5')}
                  </TypographyV3>
                </div>
              </div>
            </AccordionContent>

            <AccordionHeader>
              <TypographyV3
                variant="unset"
                Element="h4"
                weight="thin"
                className="max-w-[90%] py-4 text-xl lg:text-3xl"
              >
                {t('shipping_info_faq_question_3')}
              </TypographyV3>
            </AccordionHeader>
            <AccordionContent>
              <div className="pb-4">
                <TypographyRhythm>
                  <TypographyV3>
                    {t('shipping_info_faq_answer_3_1')}
                  </TypographyV3>
                  <TypographyV3>
                    {t('shipping_info_faq_answer_3_2')}
                  </TypographyV3>
                  <TypographyV3>
                    {t('shipping_info_faq_answer_3_3')}
                  </TypographyV3>
                  <TypographyV3>
                    {t('shipping_info_faq_answer_3_4')}
                  </TypographyV3>
                </TypographyRhythm>
              </div>
            </AccordionContent>

            <AccordionHeader>
              <TypographyV3
                variant="unset"
                Element="h4"
                weight="thin"
                className="max-w-[90%] py-4 text-xl lg:text-3xl"
              >
                {t('shipping_info_faq_question_4')}
              </TypographyV3>
            </AccordionHeader>
            <AccordionContent>
              <div className="pb-4">
                <TypographyRhythm>
                  <TypographyV3>
                    {t('shipping_info_faq_answer_4_1')}
                  </TypographyV3>
                  <TypographyV3>
                    {t('shipping_info_faq_answer_4_2')}
                  </TypographyV3>
                  <TypographyV3>
                    {t('shipping_info_faq_answer_4_3')}
                  </TypographyV3>
                </TypographyRhythm>
              </div>
            </AccordionContent>

            <AccordionHeader>
              <TypographyV3
                variant="unset"
                Element="h4"
                weight="thin"
                className="max-w-[90%] py-4 text-xl lg:text-3xl"
              >
                {t('shipping_info_faq_question_5')}
              </TypographyV3>
            </AccordionHeader>
            <AccordionContent>
              <div className="pb-4">
                <TypographyRhythm>
                  <TypographyV3>
                    {t('shipping_info_faq_answer_5_1')}
                  </TypographyV3>
                  <TypographyV3>
                    {t('shipping_info_faq_answer_5_2')}
                  </TypographyV3>
                </TypographyRhythm>
              </div>
            </AccordionContent>

            <AccordionHeader>
              <TypographyV3
                variant="unset"
                Element="h4"
                weight="thin"
                className="max-w-[90%] py-4 text-xl lg:text-3xl"
              >
                {t('shipping_info_faq_question_6')}
              </TypographyV3>
            </AccordionHeader>
            <AccordionContent>
              <div className="pb-4">
                <TypographyRhythm>
                  <TypographyV3>
                    {t('shipping_info_faq_answer_6_1')}
                  </TypographyV3>
                  <TypographyV3>
                    {t('shipping_info_faq_answer_6_2')}
                  </TypographyV3>
                </TypographyRhythm>
              </div>
            </AccordionContent>

            <AccordionHeader>
              <TypographyV3
                variant="unset"
                Element="h4"
                weight="thin"
                className="max-w-[90%] py-4 text-xl lg:text-3xl"
              >
                {t('terms_and_conditions_canada_header')}
              </TypographyV3>
            </AccordionHeader>
            <AccordionContent>
              <div className="pb-4">
                <TypographyRhythm>
                  <TypographyV3>
                    {t('shipping_info_faq_answer_7_1')}
                  </TypographyV3>
                  <TypographyV3>
                    {t('terms_of_delivery_canada_description')}
                  </TypographyV3>
                </TypographyRhythm>
              </div>
            </AccordionContent>

            <AccordionHeader>
              <TypographyV3
                variant="unset"
                Element="h4"
                weight="thin"
                className="max-w-[90%] py-4 text-xl lg:text-3xl"
              >
                {t('terms_of_delivery_dap_heading')}
              </TypographyV3>
            </AccordionHeader>
            <AccordionContent>
              <div className="pb-4">
                <TypographyRhythm>
                  <TypographyV3>
                    {t('shipping_info_faq_answer_8_1')}
                  </TypographyV3>
                  <TypographyV3>
                    {t('shipping_info_faq_answer_8_2')}
                  </TypographyV3>
                  <TypographyV3>
                    {t('shipping_info_faq_answer_8_3')}
                  </TypographyV3>
                </TypographyRhythm>
              </div>
            </AccordionContent>
          </Accordion>
        </div>
      </LayoutGrid>
    </>
  );
};

export default Content;
